import Layout from "@/components/Layout.jsx";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
      {title}
    </h2>
    <div className="space-y-3 leading-7 text-gray-600 dark:text-white/70">
      {children}
    </div>
  </section>
);

export default function Terms() {
  return (
    <Layout>
      <div className="min-h-screen bg-white dark:bg-black py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <p className="text-sm font-medium uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
              Legal
            </p>
            <h1 className="mt-2 text-4xl font-bold text-gray-900 dark:text-white">
              Terms and Conditions
            </h1>
            <p className="mt-3 text-gray-600 dark:text-white/70">
              Last updated: July 30, 2026
            </p>
          </div>

          <div className="space-y-10 rounded-2xl border border-gray-200 bg-gray-50 p-6 shadow-sm dark:border-white/20 dark:bg-white/5 sm:p-10">
            <Section title="1. Acceptance of these terms">
              <p>
                By accessing or using PrepMind, you agree to these terms. If you
                are not legally old enough to agree to them yourself, you may
                use PrepMind only with permission and supervision from a parent
                or legal guardian.
              </p>
            </Section>

            <Section title="2. Educational use only">
              <p>
                PrepMind is a free study tool. It does not provide official test
                questions, scores, admissions decisions, professional advice,
                or guaranteed academic results. PrepMind is not endorsed by or
                affiliated with the College Board, ACT, schools, colleges, or
                testing agencies. Their names and trademarks belong to their
                respective owners.
              </p>
            </Section>

            <Section title="3. AI-generated content">
              <p>
                Questions, explanations, answers, and Tutor responses may be
                generated by artificial intelligence. AI can produce incorrect,
                incomplete, outdated, misleading, or inappropriate information.
                You are responsible for checking important information against
                trusted teachers, textbooks, course materials, and official test
                sources before relying on it.
              </p>
              <p>
                PrepMind content is not medical, legal, financial, mental-health,
                or other professional advice. Do not use it to make high-stakes
                decisions.
              </p>
            </Section>

            <Section title="4. Prompts and technical data">
              <p>
                Text you submit and your selected practice settings may be sent
                to third-party AI services to generate a response. Do not submit
                confidential, sensitive, or personally identifying information.
                Basic technical information, such as an IP address, may be
                processed temporarily to protect the service and enforce usage
                limits.
              </p>
            </Section>

            <Section title="5. Acceptable use">
              <p>You agree not to:</p>
              <ul className="list-disc space-y-2 pl-6">
                <li>Use PrepMind for illegal, harmful, or abusive activity.</li>
                <li>
                  Attempt to bypass rate limits, safety controls, or access
                  restrictions.
                </li>
                <li>
                  Overload, disrupt, probe, scrape, reverse engineer, or attack
                  the website or its connected services.
                </li>
                <li>
                  Use automated tools to create excessive requests or waste
                  service resources.
                </li>
              </ul>
            </Section>

            <Section title="6. Availability and changes">
              <p>
                PrepMind may change, limit, suspend, or discontinue any feature
                at any time. The service may sometimes be slow, unavailable, or
                contain errors. Access is not guaranteed.
              </p>
            </Section>

            <Section title="7. No warranties">
              <p>
                To the fullest extent permitted by law, PrepMind is provided
                “as is” and “as available,” without warranties of accuracy,
                reliability, availability, fitness for a particular purpose, or
                freedom from errors.
              </p>
            </Section>

            <Section title="8. Limitation of liability">
              <p>
                To the fullest extent permitted by law, PrepMind and its
                operators, contributors, and service providers will not be
                liable for indirect, incidental, special, consequential, or
                punitive damages, loss of data, academic outcomes, missed
                opportunities, or other losses arising from your use of, inability
                to use, or reliance on PrepMind or its AI-generated content.
              </p>
              <p>
                Nothing in these terms excludes or limits liability that cannot
                legally be excluded or limited.
              </p>
            </Section>

            <Section title="9. Third-party services">
              <p>
                PrepMind depends on third-party services, including AI and
                hosting providers. Those services may have their own terms and
                privacy practices. PrepMind does not control and is not
                responsible for third-party services.
              </p>
            </Section>

            <Section title="10. Changes to these terms">
              <p>
                These terms may be updated as PrepMind changes. The updated date
                at the top of this page will show when the terms were last
                revised. Continuing to use PrepMind after an update means you
                accept the revised terms.
              </p>
            </Section>

            <Section title="11. Contact">
              <p>
                Questions about these terms can be sent to{" "}
                <a
                  href="mailto:support@prepmind.org"
                  className="font-medium text-emerald-600 underline underline-offset-4 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300"
                >
                  support@prepmind.org
                </a>
                .
              </p>
            </Section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
